import { render, staticRenderFns } from "./AddMatchingOrder.vue?vue&type=template&id=5791d12b&scoped=true"
import script from "./AddMatchingOrder.vue?vue&type=script&lang=js"
export * from "./AddMatchingOrder.vue?vue&type=script&lang=js"
import style0 from "./AddMatchingOrder.vue?vue&type=style&index=0&id=5791d12b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5791d12b",
  null
  
)

export default component.exports